import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, makeStyles, Paper } from "@material-ui/core";

import { AuthContext } from "../../context/Auth/AuthContext";
import { i18n } from "../../translate/i18n";
import BulkResolveTicketsModal from "../../components/BulkResolveTicketsModal";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";

import DefaultFunctionsUtils from "../../utils/classes/DefaultFunctionsUtils";

import { useGlobalRegisters } from "../../context/GlobalRegisters/GlobalRegistersContext";

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    overflowY: "scrol",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "flex-start",
    justifyContent: "center",
    gap: "1em",
    padding: "1em",
    ...theme.scrollbarStyles,
  },

  floatingButton: {
    transition: "all 0.30s ease",
    "&:hover": { transform: "translateY(-5px)", },
  },
}));

const BulkActions = () => {
  //  ***************
  //  ** Variables **
  //  ***************
  const classes = useStyles();
  const history = useHistory();
  const { user } = useContext(AuthContext);

  const [openResolveTicketsModal, setOpenResolveTicketsModal] = useState(false);

  const { setShouldSyncRouteOnMenu } = useGlobalRegisters();



  //  *****************
  //  ** Use Effects **
  //  *****************
  useEffect(() => {
    if (user.profile === "user" || !user.configEnabled) {
      DefaultFunctionsUtils.redirectToTicketsPage(history);
      setShouldSyncRouteOnMenu(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  //  ***************
  //  ** Functions **
  //  ***************
  const handleOpenResolveTicketsModal = () => {
    setOpenResolveTicketsModal(true);
  };

  const handleCloseResolveTicketsModal = () => {
    setOpenResolveTicketsModal(false);
  };



  //  ************
  //  ** Return **
  //  ************
  return (
    <MainContainer>
      <BulkResolveTicketsModal open={openResolveTicketsModal} onClose={handleCloseResolveTicketsModal} />

      <MainHeader>
        <Title>{i18n.t("bulkActions.title")}</Title>
      </MainHeader>

      <Paper className={classes.mainPaper} variant="outlined">
        <Button
          color="inherit"
          variant="outlined"
          onClick={handleOpenResolveTicketsModal}
          className={classes.floatingButton}
        >
          {i18n.t("bulkActions.buttons.closeTickets")}
        </Button>
      </Paper>
    </MainContainer>
  );
};

export default BulkActions;
